import axios from 'axios';
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { CONCURSOAPI, EVALUACIONAPI } from '../../../const';
import { isFulfilledAction, isPendingAction, isRejectedAction } from '../../../utils/redux';
import { useSelector } from 'react-redux';

type State = {
  errorAccion: string;
  successAccion: string;
  loadingAccion: boolean;
  finishedAccion: boolean;
  finalizoAvanzarEtapa: boolean;
};
const initialState: State = {
  errorAccion: '',
  loadingAccion: false,
  successAccion: '',
  finishedAccion: false,
  finalizoAvanzarEtapa: false,
};

const sliceName = 'accionesConcurso';

type RequestAvanzarEtapaConcurso = {
  idLlamadoConcurso: number;
};
export const postAvanzarEtapaConcurso = createAsyncThunk<string, RequestAvanzarEtapaConcurso>(
  `${sliceName}/postAvanzarEtapaConcurso`,
  async ({ idLlamadoConcurso }) => {
    const response = await axios.post(
      `${CONCURSOAPI}/llamadoconcurso/avanzaretapa/${idLlamadoConcurso}`,
    );
    return response.data;
  },
);

type RequestEvaluacionInicial = {
  idLlamadoConcurso: number;
};
export const postEvaluacionInicial = createAsyncThunk<string, RequestEvaluacionInicial>(
  `${sliceName}/postEvaluacionInicial`,
  async ({ idLlamadoConcurso }) => {
    const response = await axios.post(
      `${EVALUACIONAPI}/evaluaciones/evaluacion-inicial/${idLlamadoConcurso}`,
    );
    return response.data;
  },
);

const accionesConcursoSlice = createSlice({
  name: sliceName,
  initialState,
  reducers: {
    cleanMsgAccion: (state) => ({
      ...state,
      successAccion: '',
      errorAccion: '',
      finishedAccion: false,
    }),
    cleanStateAccion: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(postAvanzarEtapaConcurso.fulfilled, (state, action) => {
      state.loadingAccion = false;
      state.finishedAccion = !state.loadingAccion;
      state.finalizoAvanzarEtapa = true;
      state.successAccion = action.payload;
    });

    builder.addCase(postAvanzarEtapaConcurso.pending, (state) => {
      state.loadingAccion = true;
      state.finishedAccion = !state.loadingAccion;
      state.finalizoAvanzarEtapa = false;
    });

    builder.addMatcher(isRejectedAction(sliceName), (state, action) => {
      state.loadingAccion = false;
      state.finishedAccion = !state.loadingAccion;
      state.finalizoAvanzarEtapa = false;
      // if (action.type.includes('bases')) return;
      state.errorAccion = 'No se pudo completar la operación.';
    });

    builder.addMatcher(isPendingAction(sliceName), (state) => {
      state.loadingAccion = true;
      state.finalizoAvanzarEtapa = false;
    });

    builder.addMatcher(isFulfilledAction(sliceName), (state) => {
      state.loadingAccion = false;
      state.finishedAccion = !state.loadingAccion;
      state.finalizoAvanzarEtapa = true;
      state.successAccion = 'La acción se realizó con éxito';
    });
  },
});

export const useAccionesConcurso = () =>
  useSelector((state: any) => state.accionesConcurso) as State;
export const { cleanMsgAccion, cleanStateAccion } = accionesConcursoSlice.actions;
const accionesConcursoReducer = accionesConcursoSlice.reducer;
export default accionesConcursoReducer;
